import React, { useEffect, useRef, useState } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import { Card, Row, Col, Button, Form } from 'react-bootstrap';
import {
  createCustomer,
  getCustomerTableList
} from 'nursd-dashboard/api/customerTable';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import paths from 'routes/paths';
import Flex from 'components/common/Flex';
// import DatePicker from 'react-datepicker';
import { DatePicker } from 'rsuite';
import 'rsuite/DatePicker/styles/index.css';
import {
  formatPhoneNumber,
  removeFormatting
} from 'nursd-dashboard/utils/function';

const GOOGLE_PLACES_API_KEY = 'AIzaSyASXZSrsvL25WiY7nZc2M4WJhkDMj-jkvs';
const mapApiJs = 'https://maps.googleapis.com/maps/api/js';

function loadAsyncScript(src) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    Object.assign(script, {
      type: 'text/javascript',
      async: true,
      src
    });
    script.addEventListener('load', () => resolve(script));
    document.head.appendChild(script);
  });
}

const extractAddress = place => {
  const address = {
    street_number: '',
    route: '',
    locality: '',
    administrative_area_level_3: '',
    administrative_area_level_2: '',
    administrative_area_level_1: '',
    country: '',
    postal_code: '',
    postal_code_suffix: '',
    latitude: '',
    longitude: '',
    plain() {
      const street_number = this.street_number ? this.street_number + ', ' : '';
      const route = this.route ? this.route + ', ' : '';
      const locality = this.locality ? this.locality + ', ' : '';
      const administrative_area_level_3 = this.administrative_area_level_3
        ? this.administrative_area_level_3 + ', '
        : '';
      const administrative_area_level_2 = this.administrative_area_level_2
        ? this.administrative_area_level_2 + ', '
        : '';
      const administrative_area_level_1 = this.administrative_area_level_1
        ? this.administrative_area_level_1 + ', '
        : '';
      const country = this.country ? this.country + ', ' : '';
      const postal_code = this.postal_code ? this.postal_code + ', ' : '';
      const postal_code_suffix = this.postal_code_suffix
        ? this.postal_code_suffix + ', '
        : '';
      return (
        street_number +
        route +
        locality +
        administrative_area_level_3 +
        administrative_area_level_2 +
        administrative_area_level_1 +
        country +
        postal_code +
        postal_code_suffix
      );
    }
  };

  if (!Array.isArray(place?.address_components)) {
    return address;
  }

  place.address_components.forEach(component => {
    const types = component.types;
    const value = component.long_name;

    if (types.includes('street_number')) {
      address.street_number = value;
    }
    if (types.includes('route')) {
      address.route = value;
    }
    if (types.includes('locality')) {
      address.locality = value;
    }
    if (types.includes('administrative_area_level_3')) {
      address.administrative_area_level_3 = value;
    }
    if (types.includes('administrative_area_level_2')) {
      address.administrative_area_level_2 = value;
    }
    if (types.includes('administrative_area_level_1')) {
      address.administrative_area_level_1 = value;
    }
    if (types.includes('country')) {
      address.country = value;
    }
    if (types.includes('postal_code')) {
      address.postal_code = value;
    }
    if (types.includes('postal_code_suffix')) {
      address.postal_code_suffix = value;
    }
  });

  let points = Object.keys(place?.geometry?.viewport);

  address.latitude = place?.geometry?.viewport?.[points[0]]?.lo;
  address.longitude = place?.geometry?.viewport?.[points[1]]?.lo;

  return address;
};

function Create_customer() {
  const navigate = useNavigate();
  const [newCustomer, setNewCustomer] = useState({
    firstName: '', //
    lastName: '', //
    fullAddress: '', //
    latitude: '', //
    longitude: '', //
    city: '', //
    state: '', //
    zipCode: '', //
    gender: '', //
    patientOne: '', //
    patientTwo: '', //
    email: '', //,
    password: '',
    mrn: '',
    dateOfBirth: new Date()
  });

  const handleInputChangeNewData = event => {
    setNewCustomer(prevState => {
      return { ...prevState, [event.target.name]: event.target.value };
    });
  };

  const searchInput = useRef(null);

  const initMapScript = () => {
    if (window.google) {
      return Promise.resolve();
    }
    const src = `${mapApiJs}?key=${GOOGLE_PLACES_API_KEY}&libraries=places&v=weekly`;
    return loadAsyncScript(src);
  };

  const onChangeAddress = autocomplete => {
    const place = autocomplete.getPlace();
    handleInputChangeNewData({
      target: {
        name: 'fullAddress',
        value:
          extractAddress(place)?.street_number +
          ', ' +
          extractAddress(place)?.route +
          ', ' +
          extractAddress(place)?.locality +
          ', ' +
          extractAddress(place)?.administrative_area_level_3 +
          ', ' +
          extractAddress(place)?.administrative_area_level_2 +
          ', ' +
          extractAddress(place)?.administrative_area_level_1 +
          ', ' +
          extractAddress(place)?.country +
          ', ' +
          extractAddress(place)?.postal_code +
          ', ' +
          extractAddress(place)?.postal_code_suffix
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'latitude',
        value: extractAddress(place)?.latitude
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'longitude',
        value: extractAddress(place)?.longitude
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'city',
        value: extractAddress(place)?.locality
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'state',
        value: extractAddress(place)?.administrative_area_level_1
      }
    });
    handleInputChangeNewData({
      target: {
        name: 'zipCode',
        value: extractAddress(place)?.postal_code
      }
    });
  };

  const initAutocomplete = () => {
    if (!searchInput.current) return;

    const autocomplete = new window.google.maps.places.Autocomplete(
      searchInput.current
    );
    autocomplete.setFields(['address_component', 'geometry']);
    autocomplete.addListener('place_changed', () =>
      onChangeAddress(autocomplete)
    );
  };

  useEffect(() => {
    initMapScript().then(() => initAutocomplete());
  }, []);

  const [options] = useState(['Male', 'Female', 'Others']);
  console.log(newCustomer?.dateOfBirth);
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [orgLocationIdData, setOrgLocationIdData] = useState([]);
  const { authToken, location, organization } = useAuth();

  const getCustomer = async () => {
    try {
      const nurseList = await getCustomerTableList(
        authToken,
        location,
        organization
      );

      const list = nurseList.sort((a, b) =>
        a.firstName.toLowerCase().localeCompare(b.firstName.toLowerCase())
      );
      setOrgLocationIdData(list);
    } catch (error) {
      console.log(error);
      setOrgLocationIdData([]);
    }
  };

  useEffect(() => {
    if (location !== '') {
      getCustomer();
    }
  }, [authToken, location]);

  const dataCheck = !orgLocationIdData.some(serverItem => {
    return (
      serverItem.firstName === newCustomer.firstName ||
      serverItem.lastName === newCustomer.lastName ||
      serverItem.phoneOne === newCustomer.patientOne
    );
  });

  const postCustomer = async () => {
    setLoading(true);
    if (dataCheck) {
      try {
        await createCustomer(authToken, {
          firstName: newCustomer.firstName,
          lastName: newCustomer.lastName,
          fullAddress: newCustomer.fullAddress,
          latitude: newCustomer.latitude?.toString(),
          longitude: newCustomer.longitude?.toString(),
          cityId: '',
          city: newCustomer.city,
          state: newCustomer.state,
          zipCode: newCustomer.zipCode,
          gender: newCustomer.gender,
          phoneOne: removeFormatting(newCustomer.patientOne),
          phoneTwo: removeFormatting(newCustomer.patientTwo),
          email: newCustomer.email,
          active: true,
          organization: organization,
          location_id: location,
          password: newCustomer.password,
          additionalFields: [
            {
              mrnNumber: newCustomer.mrn,
              dateOfBirth: newCustomer.dateOfBirth
            }
          ]
        })
          .then(res => {
            toast.success(
              `${
                res?.firstName + ' ' + res?.lastName
              } information added successfully.`,
              {
                theme: 'colored'
              }
            );
            setLoading(false);
            setNewCustomer({
              firstName: '',
              lastName: '',
              fullAddress: '',
              city: '',
              state: '',
              zipCode: '',
              gender: '',
              patientOne: '',
              patientTwo: '',
              email: ''
            });
            navigate(paths.nursd_customer);
          })
          .catch(e => {
            setLoading(false);
            console.log(e);
          });
      } catch (error) {
        setLoading(false);
        console.log('data save error:', error);
      }
    } else {
      setLoading(false);
      toast.error(
        `${
          newCustomer?.firstName + ' ' + newCustomer?.lastName
        } record already stored in database!`,
        {
          theme: 'colored'
        }
      );
    }
  };

  const handleSubmit = event => {
    event.preventDefault(); // Prevent default form submission behavior

    const form = event.currentTarget;
    // console.log(form.checkValidity());
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    postCustomer();
  };

  return (
    <Card>
      <Card.Header>
        <h5 className="mb-0">Create Patient - {location}</h5>
      </Card.Header>
      <Card.Body>
        <Form
          noValidate
          validated={validated}
          onSubmit={loading ? null : handleSubmit}
        >
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="FirstName">
              <Form.Label>First name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="First name"
                name="firstName"
                value={newCustomer.firstName}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a first name.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="LastName">
              <Form.Label>Last name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Last name"
                name="lastName"
                value={newCustomer.lastName}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a last name.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Email">
              <Form.Label>Email</Form.Label>
              <InputGroup hasValidation>
                <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Email"
                  aria-describedby="inputGroupPrepend"
                  // required
                  name="email"
                  value={newCustomer.email}
                  onChange={handleInputChangeNewData}
                />
                {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                <Form.Control.Feedback type="invalid">
                  Please enter a email.
                </Form.Control.Feedback> */}
              </InputGroup>
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="Gender">
              <Form.Label>Gender</Form.Label>
              {/* <Form.Control required type="text" placeholder="Gender" /> */}
              <Form.Select
                onChange={e =>
                  setNewCustomer(prevState => {
                    return { ...prevState, gender: e.target.value };
                  })
                }
                size="sm"
                required
                value={newCustomer.gender}
              >
                <option value="">Select Gender</option>
                {options.map(option => (
                  <option key={option}>{option}</option>
                ))}
              </Form.Select>
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please choose a gender.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="PrimaryPhoneNumber">
              <Form.Label>Primary Phone Number</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Primary Phone Number"
                name="patientOne"
                value={formatPhoneNumber(newCustomer.patientOne)}
                onChange={handleInputChangeNewData}
                // pattern="[0-9]*"
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a primary phone number.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="SecondaryPhoneNumber">
              <Form.Label>Secondary Phone Number</Form.Label>
              <Form.Control
                // required
                type="text"
                placeholder="Secondary Phone Number"
                name="patientTwo"
                value={formatPhoneNumber(newCustomer.patientTwo)}
                onChange={handleInputChangeNewData}
                // pattern="[0-9]*"
              />
              {/* <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a secondary phone number.
              </Form.Control.Feedback> */}
            </Form.Group>
          </Row>
          <Row className="mb-3">
            {/* <Button as={Col} md="4" variant="primary" onClick={handleShow}>
            Launch static backdrop modal
          </Button> */}
            <Form.Group as={Col} md="4" controlId="FullAddress">
              <Form.Label>Full Address</Form.Label>
              <Form.Control
                required
                ref={searchInput}
                contentEditable={false}
                type="text"
                placeholder="Full Address"
                value={newCustomer.fullAddress}
                name="fullAddress"
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please choose a full address.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="Password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Password"
                name="password"
                value={newCustomer.password}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a password.
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="4" controlId="MRN">
              <Form.Label>MRN Number</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="MRN Number"
                name="mrn"
                value={newCustomer.mrn}
                onChange={handleInputChangeNewData}
              />
              <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                Please enter a MRN Number.
              </Form.Control.Feedback>
            </Form.Group>
          </Row>
          <Form.Group as={Col} md="4" controlId="DateOfBirth">
            <Form.Label>Date Of Birth</Form.Label>
            <DatePicker
              value={newCustomer.dateOfBirth}
              onChangeCalendarDate={date =>
                setNewCustomer(prevState => {
                  return { ...prevState, dateOfBirth: date };
                })
              }
              className="mx-2"
              // popperPlacement="bottom-start"
              // selected={newCustomer.dateOfBirth}
              // onChange={date =>
              //   setNewCustomer(prevState => {
              //     return { ...prevState, dateOfBirth: date };
              //   })
              // }
              // formatWeekDay={day => day.slice(0, 3)}
              // className="form-control"
              // placeholderText="Select Date"
            />
          </Form.Group>

          <Flex className="mt-2">
            <Button type="submit">
              {loading ? 'Loading...' : 'Create Patient'}
            </Button>
            <Button
              as={Link}
              to={paths.nursd_customer}
              variant="secondary"
              className="mx-2"
            >
              Cancel
            </Button>
          </Flex>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default Create_customer;
